export default __webpack_public_path__ + "static/media/access_denied.088a192a.svg";